"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountStore = void 0;
const common_1 = require("../common");
const deepmerge_1 = __importDefault(require("deepmerge"));
class AccountStore extends common_1.HasMapStore {
    constructor(eventListener, accountSetCreator, chainGetter, queriesStore, storeOpts) {
        var _a;
        super((chainId) => {
            var _a, _b;
            return new accountSetCreator(this.eventListener, this.chainGetter, chainId, this.queriesStore, deepmerge_1.default(deepmerge_1.default({
                msgOpts: accountSetCreator.defaultMsgOpts,
            }, this.storeOpts.defaultOpts), (_b = (_a = this.storeOpts.chainOpts) === null || _a === void 0 ? void 0 : _a.find((opts) => opts.chainId === chainId)) !== null && _b !== void 0 ? _b : {}));
        });
        this.eventListener = eventListener;
        this.accountSetCreator = accountSetCreator;
        this.chainGetter = chainGetter;
        this.queriesStore = queriesStore;
        this.storeOpts = storeOpts;
        const defaultOpts = deepmerge_1.default({
            msgOpts: accountSetCreator.defaultMsgOpts,
        }, this.storeOpts.defaultOpts);
        for (const opts of (_a = this.storeOpts.chainOpts) !== null && _a !== void 0 ? _a : []) {
            if (opts.prefetching ||
                (defaultOpts.prefetching && opts.prefetching !== false)) {
                this.getAccount(opts.chainId);
            }
        }
    }
    getAccount(chainId) {
        return this.get(chainId);
    }
    hasAccount(chainId) {
        return this.has(chainId);
    }
}
exports.AccountStore = AccountStore;
//# sourceMappingURL=store.js.map